export default [
  //
  'exodus:events:*',
  'exodus:ui:*',
].join(',')
